/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const NoSearchData = (): JSX.Element => (
  <svg width="136" height="250" viewBox="0 0 136 250">
    <path
      d="M53.9195 39.0213C53.9195 39.0213 44.8236 31.9913 48.4808 21.7478C51.7145 12.6974 60.9658 9.15755 67.6994 11.4025C67.6994 11.4025 69.7774 42.1112 53.9195 39.0213Z"
      fill="#131212"
    />
    <path
      d="M69.2091 13.2564C68.2479 13.1712 67.2785 13.2385 66.3379 13.4549C57.571 15.4467 54.8314 27.9204 56.9795 35.5927C58.1683 39.8383 61.4641 43.4648 65.7693 44.2657C72.064 45.4355 77.1821 40.5926 79.2639 34.7839C80.8776 30.44 80.8141 25.649 79.0839 21.3493C77.2948 17.1805 73.604 13.6461 69.2091 13.2564Z"
      fill="#F3B6B5"
    />
    <path
      d="M57.1032 31.7382C55.4555 32.14 53.7195 31.6289 52.5516 30.3999C51.4623 29.0928 51.0891 27.3311 51.5567 25.6955C51.9204 24.2175 53.0619 23.057 54.5332 22.6668C56.0588 22.4245 57.5125 23.3997 57.8667 24.9036L57.1032 31.7382Z"
      fill="#F3B6B5"
    />
    <path
      d="M57.5804 27.3535L48.2198 46.6155C46.4377 50.1445 47.7102 54.4512 51.1251 56.4437C54.6914 58.5244 59.2689 57.3198 61.3496 53.7535C61.5355 53.4352 61.6971 53.1027 61.8341 52.7607L69.3895 34.2418L57.5804 27.3535Z"
      fill="#F3B6B5"
    />
    <path
      d="M64.2272 46.6255L65.3904 43.9211C61.4189 42.7844 58.3066 39.6904 57.1482 35.7251C57.1482 35.7251 57.1021 42.0772 64.2272 46.6255Z"
      fill="#DFA8A8"
    />
    <path
      d="M57.1135 23.4532C63.9964 26.8356 72.6084 25.7437 79.2048 21.8347C76.9693 15.9345 71.6562 11.7534 65.3971 10.9662C56.3602 9.64416 57.1135 23.4532 57.1135 23.4532Z"
      fill="#131212"
    />
    <path
      d="M55.4546 28.2841C54.7026 28.056 54.2676 27.2722 54.4712 26.5135C54.7305 26.0242 55.2754 25.7582 55.821 25.8545"
      stroke="#1E1C1C"
      strokeWidth="0.639"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M72.3889 35.8209L73.8494 35.2325C73.227 34.6027 73.1022 31.9092 73.1022 31.9092"
      stroke="#1E1C1C"
      strokeWidth="0.639"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M72.9416 38.1884C72.9416 38.1884 69.4201 39.6909 68.9661 34.8291"
      stroke="#1E1C1C"
      strokeWidth="0.639"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M71.1282 28.4304C71.1282 28.4304 70.3206 31.7198 68.6546 30.972C66.9898 30.2248 67.9834 27.0195 67.9834 27.0195"
      stroke="#1E1C1C"
      strokeWidth="0.639"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M79.2462 31.4199C79.2462 31.4199 78.499 34.2342 77.2123 33.6574C75.9249 33.0799 76.818 30.332 76.818 30.332"
      stroke="#1E1C1C"
      strokeWidth="0.639"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M49.0462 6.49543C46.6784 11.7936 49.0523 18.0087 54.3499 20.3785C59.7118 22.5936 65.8549 20.0446 68.0741 14.684C70.4433 9.38578 68.0707 3.17075 62.7739 0.799559C57.4099 -1.4169 51.2654 1.13277 49.0462 6.49543Z"
      fill="#131212"
    />
    <path d="M58.4403 239.33L45.8433 239.277L48.9338 218.695L61.5295 218.748L58.4403 239.33Z" fill="#F3B6B5" />
    <path
      d="M80.0129 250.001L42.3813 249.845L44.5808 238.64C44.6555 237.846 45.3199 237.242 46.1139 237.242L55.0252 237.276C55.0659 234.276 56.7829 233.319 58.2284 233.055C59.3142 232.865 60.4136 233.306 61.0584 234.202L63.7254 237.839L75.7436 242.936C78.3767 244.307 80.0272 247.028 80.0129 250.001Z"
      fill="#A05C47"
    />
    <path
      d="M32.0933 140.32C32.9715 140.907 47.6689 183.985 47.6689 183.985L43.6364 226.209L66.3866 228.072L73.0625 194.019C74.3241 187.593 73.9684 180.953 72.0275 174.698C65.75 154.458 52.2973 116.95 52.2973 116.95L31.2341 111.712L32.0933 140.32Z"
      fill="#228F9D"
    />
    <path d="M16.0625 239.331L3.46484 239.28L6.5554 218.698L19.1511 218.751L16.0625 239.331Z" fill="#F3B6B5" />
    <path
      d="M37.6377 250.001L0 249.845L2.2056 238.64C2.27346 237.846 2.94532 237.242 3.73934 237.242L12.65 237.276C12.6839 234.276 14.4076 233.326 15.8464 233.055C16.9322 232.865 18.0316 233.306 18.6763 234.202L21.3366 237.832L33.369 242.936C36.0022 244.307 37.6513 247.028 37.6377 250.001Z"
      fill="#A05C47"
    />
    <path
      d="M12.5349 103.347C12.5349 103.347 5.8163 105.926 8.09791 134.294C8.56142 140.07 8.8227 145.861 8.97404 151.652L9.75787 181.703L0.953125 224.689L24.1777 226.226L35.8878 194.865C38.7238 187.282 40.1137 179.232 39.9841 171.136C39.6325 149.759 36.7944 113.684 36.7944 113.684L12.5349 103.347Z"
      fill="#228F9D"
    />
    <path
      d="M39.2509 161.007L36.7969 136.847L44.5524 131.965"
      stroke="#117683"
      strokeWidth="1.179"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.4693 74.3507L78.7617 75.5516C78.4118 75.6561 83.5387 84.3738 83.5387 84.3738C83.5387 84.3738 100.612 82.4086 101.708 81.7313C102.803 81.0534 96.2397 80.8126 96.2397 80.8126C96.2397 80.8126 102.472 79.8504 104.106 78.7117C105.406 77.8088 96.9161 77.5971 96.9161 77.5971C100.065 76.9048 105.979 75.9824 105.921 74.9445C105.847 73.6426 95.8947 75.1912 95.8947 75.1912C95.8947 75.1912 102.77 73.5417 103.047 72.2938C103.323 71.0466 89.9037 72.75 89.9037 72.75C89.9037 72.75 92.0138 70.4406 91.6694 67.5675C91.4955 66.8731 90.9011 66.3648 90.1888 66.3026C89.3786 69.9475 82.4693 74.3507 82.4693 74.3507Z"
      fill="#F3B6B5"
    />
    <path
      d="M40.6617 56.731C40.6617 56.731 34.8172 72.672 36.5592 85.0432C39.4607 105.661 88.1981 82.9721 88.1981 82.9721L86.0604 73.5133C86.0604 73.5133 51.8911 78.1338 52.2271 76.8769C53.075 73.7098 55.4943 63.0534 55.4943 63.0534L40.6617 56.731Z"
      fill="#F3B6B5"
    />
    <path
      d="M63.9276 53.7764L47.6949 43.7874C47.6949 43.7874 38.6189 50.2158 32.9624 57.1346C9.96586 83.2879 6.14351 122.761 6.14351 122.761C6.14351 122.761 27.3218 126.977 54.1729 113.764L63.9276 53.7764Z"
      fill="#F7F7F7"
    />
    <path d="M93.3726 87.6589L96.0403 89.8795L102.67 81.8219L100.004 79.6021L93.3726 87.6589Z" fill="#133950" />
    <path
      d="M77.4994 107.089L80.0606 109.221C80.5445 109.625 81.2638 109.559 81.6676 109.075L97.7298 89.5279C98.1329 89.044 98.0678 88.3246 97.5839 87.9208C97.5832 87.9208 97.5832 87.9202 97.5825 87.9202L95.0206 85.7865C94.5361 85.3834 93.8167 85.4492 93.4129 85.9338L77.3514 105.482C76.9483 105.967 77.0141 106.685 77.4987 107.088C77.4987 107.089 77.4994 107.089 77.4994 107.089Z"
      fill="#D9D9D9"
    />
    <path
      d="M120.357 39.3897C122.472 39.3489 124.55 39.9441 126.324 41.0971C128.123 42.3214 129.502 44.0689 130.275 46.1028C131.154 48.4102 131.541 50.8751 131.41 53.3406C131.285 56.2465 130.727 59.1172 129.756 61.8589C128.668 64.9834 127.187 67.9566 125.345 70.7051C122.69 74.781 119.252 78.2896 115.233 81.0293C111.533 83.4806 107.784 84.7768 104.394 84.7768C99.9889 84.9023 95.995 82.2 94.4742 78.0636C93.596 75.7562 93.2099 73.2914 93.3408 70.8259C93.4664 67.9206 94.0236 65.0492 94.9947 62.3075C96.0819 59.183 97.5641 56.2099 99.4059 53.4614C102.061 49.3854 105.498 45.8768 109.518 43.1371C113.218 40.6859 116.968 39.3897 120.357 39.3897ZM103.453 81.1121C103.621 81.1121 103.792 81.108 103.967 81.0992C106.813 80.8386 109.548 79.8715 111.924 78.2855C113.818 77.0938 115.572 75.6938 117.155 74.1126C118.912 72.3678 120.487 70.4485 121.854 68.3841C125.405 63.0432 127.437 57.0202 127.431 51.8625C127.427 48.6728 126.628 46.0431 125.123 44.2657C124.703 43.7527 124.213 43.302 123.667 42.9268C122.373 42.0954 120.861 41.6699 119.323 41.7052C117.76 41.7323 116.214 42.0343 114.756 42.5976C113.042 43.2464 111.414 44.1028 109.91 45.148C106.342 47.6488 103.283 50.8085 100.9 54.4563C97.3537 59.7918 95.3171 65.81 95.3123 70.9677C95.2791 72.7098 95.5654 74.4431 96.1572 76.0813C96.6615 77.4915 97.5532 78.7314 98.7293 79.6578C98.8453 79.746 98.9655 79.8315 99.0856 79.9116L99.1121 79.9285C99.6624 80.2787 100.259 80.5502 100.884 80.7361L100.951 80.7565C101.742 80.992 102.562 81.1114 103.385 81.1121H103.453Z"
      fill="#D9D9D9"
    />
    <path
      d="M100.897 54.4567C107.56 44.4331 117.988 39.154 123.667 42.9286C124.214 43.3032 124.706 43.7545 125.126 44.2675C119.238 42.4148 110.168 47.5719 104.156 56.6189C98.1415 65.6659 96.8969 76.0261 100.885 80.7373C100.25 80.5486 99.6447 80.2711 99.0875 79.9127C93.4086 76.1381 94.2386 64.481 100.897 54.4567Z"
      fill="#133950"
    />
    <path
      d="M125.347 70.7033C133.05 59.1134 133.491 45.8587 126.325 41.0967L129.91 43.4801C137.073 48.2408 136.637 61.4968 128.932 73.0867C121.227 84.6766 109.176 90.2116 102.012 85.4496L98.4297 83.0668C105.591 87.8289 117.643 82.2932 125.347 70.7033Z"
      fill="#133950"
    />
    <path
      d="M81.042 97.4953L77.4085 98.9137C77.0638 99.0352 82.6931 107.447 82.6931 107.447C82.6931 107.447 99.6308 104.496 100.687 103.757C101.743 103.018 95.1728 103.156 95.1728 103.156C95.1728 103.156 101.344 101.831 102.909 100.6C104.153 99.6209 95.6648 99.9032 95.6648 99.9032C98.7648 99.0291 104.62 97.7661 104.5 96.7319C104.349 95.4377 94.4948 97.5591 94.4948 97.5591C94.4948 97.5591 101.273 95.5144 101.478 94.2521C101.684 92.9905 88.3782 95.4648 88.3782 95.4648C88.3782 95.4648 90.353 93.0353 89.8433 90.1856C89.6296 89.5016 89.0045 89.0279 88.2886 89.0068C87.688 92.6973 81.042 97.4953 81.042 97.4953Z"
      fill="#F3B6B5"
    />
    <path
      d="M40.1307 81.1592C40.1307 81.1592 34.8556 97.2987 37.0313 109.602C40.6661 130.1 88.5663 105.699 88.5663 105.699L86.0967 96.3249C86.0967 96.3249 52.1135 102.152 52.404 100.883C53.1403 97.6876 55.1796 86.9528 55.1796 86.9528L40.1307 81.1592Z"
      fill="#F3B6B5"
    />
    <path
      d="M32.1814 87.7547L55.0402 94.7862C55.0402 94.7862 68.5331 56.2011 54.7742 50.1469C38.2777 42.8915 32.1814 87.7547 32.1814 87.7547Z"
      fill="#228F9D"
    />
  </svg>
);
